import { NgModule } from '@angular/core';
import { LibFloppyIconComponent } from './lib-floppy-icon.component';

@NgModule({
  declarations: [LibFloppyIconComponent],
  imports: [],
  exports: [LibFloppyIconComponent],
})
export class LibFloppyIconModule {}
